var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Lives"},_vm._l((3),function(life){return _c('svgicon',{key:life,staticClass:"Life",class:{ isFull: life <= _vm.remaining },attrs:{"icon":"heart-like"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }